<mat-dialog-content
  *ngIf="currentState$ | async as state"
  class="mat-mdc-dialog-surface mdc-dialog__surface bg-[#FFFFFF] !min-h-max !rounded-none"
  style="
    overflow: hidden;
    max-height: 500px;
    display: flex;
    flex-direction: column;
  "
>
  <!-- Close Icon -->
  <button
    style="position: absolute; right: 8px; top: 8px; color: #000000"
    mat-icon-button
    mat-dialog-close
    aria-label="Close"
    [disabled]="state.isLoading"
  >
    <mat-icon class="font-bold" style="font-size: 25px !important"
      >close</mat-icon
    >
  </button>

  <div
    class="header bg-[#DEE2E6] h-[3rem] flex justify-start items-center border-[#63A2D8] text-[#FFFFFF]"
  >
    <span class="p-[15px] !pl-[29px] font-roboto text-[20px] font-semibold">
      {{
        dialogueInjectedData?.approvalResponses?.length > 0
          ? "Approval Status"
          : "Send for Approval"
      }}
    </span>
  </div>

  <div style="flex: 1; overflow-y: auto">
    <ng-container>
      <div class="section-color">
        <div>
          <div
            *ngIf="dialogueInjectedData?.approvalResponses?.length > 0"
            class="uers-responses mb-[1.5625rem] !p-[30px]"
          >
            <table class="justify-center border-collapse">
              <thead class="sticky top-0 bg-[#1A4971] !z-20">
                <tr>
                  <th class="py-2 px-4 border-b text-left">Name</th>
                  <th class="py-2 px-4 border-b text-left">Title</th>
                  <th class="py-2 px-4 border-b text-left">Email</th>
                  <th class="py-2 px-4 border-b text-left">Status</th>
                  <th class="py-2 px-4 border-b text-left">Feedback</th>
                </tr>
              </thead>
              <!-- state.selectedUsers -->
              <tbody>
                <tr
                  *ngFor="
                    let response of dialogueInjectedData?.approvalResponses
                  "
                  style="max-height: calc(40vh - 170px); overflow-y: auto"
                >
                  <td class="py-2 px-4 border-b">{{ response.userName }}</td>
                  <td class="py-2 px-4 border-b">{{ response?.userTitle }}</td>
                  <td class="py-2 px-4 border-b">{{ response?.user?.email ? response.user.email : response?.email }}</td>
                  <td class="py-2 px-4 border-b text-[#aaaa19] font-bold">
                    <span
                      [ngClass]="{
                      'status-approved':
                      response?.status === 'approved',
                      'status-pending':
                      response?.status === 'pending',
                       'status-rejected':
                      response?.status === 'rejected',
                      
                      }"
                    >
                      {{ response?.status | titlecase }}
                    </span>
                  </td>
                  <td class="py-2 px-4 border-b font-bold">
                    <div class="flex justify-between items-center">
                      <div
                        [innerHTML]="
                          getSanitizedHtml(
                            response?.feedback
                              ? response?.feedback
                              : 'No comment added'
                          )
                        "
                      ></div>
                      <ng-container *ngIf="isUserApprover(response?.user?.id)">
                        <button
                          *ngIf="
                            response.status === 'rejected' && response.user
                          "
                          class="ml-2 px-3 py-1 !bg-[#e76b3f] text-white rounded"
                          (click)="resendApprovalRequest(response.user.id)"
                        >
                          Resend
                        </button>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="dialogueInjectedData?.approvalResponses?.length === 0">
            <div class="flex ml-[32px] mt-[1.625rem] !mb-[1.25rem]">
              <div class="autocomplete-container relative" #dropdownContainer>
                <!-- TODO: why is this not working. it was working before -->
                <label class="send-to-label">Send to</label>
                <mat-form-field
                  appearance="outline"
                  class="w-[335px] custom-height"
                >
                  <mat-label class="relative top-[-3px]"
                    >Select Users</mat-label
                  >
                  <mat-select
                    class="relative top-[-3px]"
                    [formControl]="userControl"
                    (selectionChange)="onSelectionChange($event.value)"
                  >
                    <mat-option
                      class="!bg-white !border-t hover:!bg-[#efc5b7]"
                      *ngFor="let user of state.filteredUsers"
                      [value]="user"
                    >
                      {{ user.name }}
                    </mat-option>
                    <mat-option
                      *ngIf="state.filteredUsers.length === 0"
                      disabled
                    >
                      No users found
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div
              class="uers-responses mb-[10px]"
              style="
                max-height: calc(45vh - 170px);
                overflow-y: auto;
                overflow-x: hidden;
              "
            >
              <table
                class="table-fixed w-[100%] justify-center border-collapse"
              >
                <thead class="sticky top-[-1px] bg-[#1A4971]">
                  <tr>
                    <th class="py-2 px-4 border-b text-left">Name</th>
                    <th class="py-2 px-4 border-b text-left">Email</th>
                    <th class="py-2 px-4 border-b text-left">Title</th>
                    <th class="py-2 px-4 !pl-0 border-b !text-center">
                      Status
                    </th>
                    <th class="py-2 px-4 border-b !text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="hover:bg-[#fdf0ec]" *ngFor="let user of state.selectedUsers">
                    <td class="py-2 pl-[21px] border-b">{{ user.name }}</td>
                    <td class="py-2 pl-[21px] border-b">{{ user.email }}</td>
                    <td class="py-2 pl-[21px] border-b">Test Designation</td>
                    <td
                      class="py-2 pl-[21px] border-b text-[#aaaa19] font-bold !text-center"
                    >
                      <span
                        [ngClass]="{ 'status-pending': pending === 'pending' }"
                      >
                        {{ pending === "pending" ? "Pending" : "Received" }}
                      </span>
                    </td>
                    <td class="py-2 px-4 border-b font-bold !text-center">
                      <button
                        type="button"
                        (click)="remove(user)"
                        class="items-center justify-center text-black hover:text-red-600"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="mt-[20px] ml-[32px] text-[18px] font-semibold send-to-label"
            >
              Comments
              <span class="text-red-500">*</span>
            </div>
            <div class="flex mx-[32px] mt-[20px]">
              <app-rich-textEditor
                class="w-[100%]"
                (contentChange)="addNote($event)"
                [resetEditor]="resetRichTextEditor"
              ></app-rich-textEditor>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- close send btns -->
  <div
    *ngIf="dialogueInjectedData?.approvalResponses?.length === 0"
    class="flex justify-end p-4 !px-[2rem] bg-white shadow-lg sticky bottom-0"
  >
    <button
      mat-dialog-close
      type="button"
      class="bg-[#F1F3F5] text-[#E76B3F] font-bold py-2  border border-[#E76B3F] rounded inline-flex  h-[2.5rem] justify-center px-[22px] items-center mr-[12px]"
      (click)="closeSendForApproval()"
      [disabled]="state.isLoading"
    >
      <span>Close</span>
    </button>
    <button
      [disabled]="
        state.isLoading || state.selectedUsers.length === 0 || !Comment
      "
      [ngClass]="{
        'bg-[#ADB5BD] cursor-not-allowed':
          state.selectedUsers.length === 0 || !Comment,
        'bg-[#E76B3F]': state.selectedUsers.length > 0 && Comment
      }"
      class="bg-[#E76B3F] text-white font-semibold py-2  px-[22px] rounded inline-flex justify-center h-[2.5rem] items-center"
      type="button"
      (click)="sendApprovalRequest()"
    >
      <ng-container *ngIf="state.isLoading; else normalTextSave">
        <div class="spinner"></div>
      </ng-container>
      <ng-template #normalTextSave>Send</ng-template>
    </button>
  </div>
</mat-dialog-content>
